import { render, staticRenderFns } from "./leave-form.vue?vue&type=template&id=2c4ff1d7&"
import script from "./leave-form.vue?vue&type=script&lang=js&"
export * from "./leave-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports